"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M22 0H5.5a2 2 0 0 0-2 2v16.5a2 2 0 0 0 2 2H22a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM9.67 12.43a1 1 0 0 1 .83-.55 1 1 0 0 1 .89.45l.83 1.24a.25.25 0 0 0 .22.11.23.23 0 0 0 .21-.13L15.09 9a1 1 0 0 1 .91-.5 1 1 0 0 1 .87.57l3.58 7.6a.48.48 0 0 1 0 .48.49.49 0 0 1-.42.24H8a.52.52 0 0 1-.43-.24.53.53 0 0 1 0-.49ZM7.75 6.25a2 2 0 1 1 2 2 2 2 0 0 1-2-2Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M19.5 22h-17a.5.5 0 0 1-.5-.5v-17a1 1 0 0 0-2 0V22a2 2 0 0 0 2 2h17.5a1 1 0 0 0 0-2Z"
})), 'FilterImage');

exports.default = _default;